import { AtomEffect } from 'recoil';

/**
 * Sync the atom with localStorage
 * @param key The key to use. If undefined, one will be generated
 */
const localStorageEffect =
  (key?: string): AtomEffect<unknown> =>
  ({ node, setSelf, onSet }) => {
    const resolvedKey = key ?? `ra-${node.key}`;
    const savedValue = localStorage.getItem(resolvedKey);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }

    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(resolvedKey);
      } else {
        localStorage.setItem(resolvedKey, JSON.stringify(newValue));
      }
    });
  };

export default localStorageEffect;
